import React from 'react';
import PropTypes from 'prop-types';

const PlaneIcon = ({ className, color }) => (
  <svg
    className={className}
    width='15px'
    height='14px'
    viewBox='0 0 15 14'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Design' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <path
        d='M14.5,8.5 L8.60526316,4.75 L8.60526316,0.625 C8.60526316,0.0025 8.11157895,-0.5 7.5,-0.5 C6.88842105,-0.5 6.39473684,0.0025 6.39473684,0.625 L6.39473684,4.75 L0.5,8.5 L0.5,10 L6.39473684,8.125 L6.39473684,12.25 L4.92105263,13.375 L4.92105263,14.5 L7.5,13.75 L10.0789474,14.5 L10.0789474,13.375 L8.60526316,12.25 L8.60526316,8.125 L14.5,10 L14.5,8.5 Z'
        id='airplane_blue'
        fill='rgba(0, 0, 0, 0.54)'
        // fill='#2974FF'
        transform='translate(7.500000, 7.000000) rotate(-270.000000) translate(-7.500000, -7.000000) '
      />
    </g>
  </svg>
);

PlaneIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default PlaneIcon;



// WEBPACK FOOTER //
// ./src/icons/PlaneIcon.js